import cn from "classnames";

import { Loader } from "shared/ui/components/Loader";
import { Typography } from "shared/ui/components/Typography";

import styles from "./Loading.module.scss";

const Loading = ({
  className,
  loadingText,
}: {
  className?: string;
  loadingText?: string;
}) => (
  <div className={cn(styles.loadingWrapper, className)}>
    <Loader color="#14A077" />
    {loadingText && (
      <Typography className={styles.loadingText} variant="bodyM">
        {loadingText}
      </Typography>
    )}
  </div>
);

export default Loading;
